/**
 * --------------------------------------------------------------------------
 * Basic Modules: Accordion.js
 * --------------------------------------------------------------------------
 */

import Util from "./util";

/**
 * ------------------------------------------------------------------------
 * Constants
 * ------------------------------------------------------------------------
 */

const DEBUG             = true;
const NAME              = 'productFilter';
const DATA_KEY          = NAME;
const EVENT_KEY         = `.${DATA_KEY}`;
const LOG_KEY           = `[${NAME}]`;

const Default = {
};

const Event = {
    RESIZE              : `resize${EVENT_KEY} orientationchange${EVENT_KEY}`,
    SCROLL              : `scroll${EVENT_KEY}`,
    CLICK               : `click${EVENT_KEY}`,
};

const ClassName = {
    ACTIVE              : 'is-active',
};

const Selector = {
    TOGGLE              : '.js-product-filter',
    FILTER_PANEL        : '.store-product-filter-panel',
    FILTER_TITLE        : '.store-product-filter-block-option-title',
    FILTER_CONTENT      : '.store-product-filter-block-options'
};

const DataAttr = {
};

class ProductFilter {

    constructor(element, config) {

        DEBUG && console.log(LOG_KEY, 'Init');

        this._element = element;
        this._config  = this._getConfig(config);
        this._filterPanels = $(this._element).find(Selector.FILTER_PANEL);

        if (this._filterPanels.length > 0) {
            this._init();
        }
    }

    destroy() {
        $(this._element).off(EVENT_KEY);
        $.removeData(this._element, DATA_KEY);
        this._element = null;
    }

    // Private

    _init() {

        this._checkForActiveFiltersOnLoad();

        this._filterPanels.each((idx, panel) => {
            $(panel).find('a').on(Event.CLICK, (event) => this._activateSelectedPanel(event));
        });
    }

    _activateSelectedPanel(event) {

        event.preventDefault();

        let selectedPanel = $(event.currentTarget).closest(Selector.FILTER_PANEL);

        this._toggleSelectedPanel(selectedPanel[0]);
    }

    _toggleSelectedPanel(selectedPanel) {

        if (selectedPanel.classList.contains(ClassName.ACTIVE)) {
            selectedPanel.classList.remove(ClassName.ACTIVE);
        }
        else {
            selectedPanel.classList.add(ClassName.ACTIVE);
        }
    }

    _checkForActiveFiltersOnLoad() {
        for (let i = 0; i < this._filterPanels.length; ++i) {

            let checked = $(this._filterPanels[i]).find(':checked');

            if (checked[0]) {
                this._toggleSelectedPanel(this._filterPanels[i]);
            }
        }
    }

    _getConfig(config) {
        return {
            ...Default,
            ...config
        };
    }

    // Static

    /**
     * Convenient static method to initiate the module.
     *
     * @param config
     * @param selector
     */
    static bind (config, selector) {
        ProductFilter._jQueryInterface.call($(selector || Selector.TOGGLE), config);
    }

    /**
     * jQuery Interface
     * @param config
     * @returns {*}
     */
    static _jQueryInterface(config) {
        return this.each(function() {
            const $this = $(this);
            let data    = $this.data(DATA_KEY);
            let _config = {
                ...Default,
                ...$this.data(),
                ...typeof config === 'object' && config ? config : {}
            };

            if (!data) {
                data = new ProductFilter(this, _config);
                $this.data(DATA_KEY, data);
            }

            if (typeof config === 'string') {
                if (typeof data[config] === 'undefined') {
                    throw new TypeError(`No method named "${config}"`);
                }
                data[config]();
            }
        });
    }
}

/**
 * ------------------------------------------------------------------------
 * jQuery
 * ------------------------------------------------------------------------
 */

$.fn[NAME] = ProductFilter._jQueryInterface;
$.fn[NAME].Constructor = ProductFilter;


export default ProductFilter;
